import React from "react";
import { Link } from "react-router-dom";

const statsData = [
  {
    value: "85%",
    label: "Fewer Missed Appointments",
    desc: "CAPRO answers every call and books every appointment automatically",
  },
  {
    value: "340%",
    label: "Social Engagement Boost",
    desc: "VAPRO keeps your brand active across every platform, every day",
  },
  {
    value: "3x",
    label: "Lead Qualification Rate",
    desc: "SAPRO qualifies leads instantly so your team only meets buyers",
  },
  {
    value: "2 days",
    label: "From Job Posted to Shortlist",
    desc: "HAPRO screens and shortlists candidates. No more 14-day cycles",
  },
];

const StatsSection: React.FC = () => {
  return (
    <section className="stats-section pb-130" style={{ position: "relative", overflow: "hidden", marginTop: "-150px", zIndex: 10, background: "linear-gradient(to bottom, transparent 150px, #00020F 150px)" }}>
      {/* Strict CSS Override for Button Alignment */}
      <style>{`
        .stats-section .agency-btn {
          margin: 0 !important;
          display: flex !important;
          margin-left: -35px !important; /* Pulling it left to match the 'A' in 'Advanced' precisely */
        }
        @media (max-width: 991px) {
          .stats-section .agency-btn {
            margin: 0 auto !important;
            margin-left: auto !important;
          }
          .stats-section .sec-title {
            text-align: center !important;
          }
          .stats-section .xb-heading-btn {
            justify-content: center !important;
          }
        }
        .stat-card {
          padding: 45px 35px !important;
        }
        .stat-value {
          font-family: 'Inter', sans-serif !important;
          font-style: normal !important;
          font-weight: 400 !important;
          letter-spacing: -1.2px !important;
          color: rgb(255, 255, 255) !important;
          font-size: 56px !important;
          line-height: 1.0 !important;
          margin-bottom: 20px !important;
        }
        .stat-card .label-badge {
          margin-bottom: 24px !important;
        }
        @media (max-width: 767px) {
          .stat-card {
            padding: 20px 15px !important;
            text-align: center !important;
          }
          .stat-value {
            font-size: 36px !important;
            line-height: 1.0 !important;
            letter-spacing: -0.8px !important;
            margin-bottom: 12px !important;
          }
          .stat-card .label-badge {
            margin-bottom: 12px !important;
          }
        }
      `}</style>

      {/* Subtle Background Glows */}
      <div
        style={{
          position: "absolute",
          top: "20%",
          left: "-10%",
          width: "400px",
          height: "400px",
          background: "radial-gradient(circle, rgba(186, 107, 231, 0.1) 0%, transparent 70%)",
          filter: "blur(60px)",
          zIndex: 0
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "10%",
          right: "-5%",
          width: "500px",
          height: "500px",
          background: "radial-gradient(circle, rgba(76, 189, 212, 0.08) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0
        }}
      />

      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div className="row align-items-center">
          {/* Left Column */}
          <div className="col-lg-5 col-md-12">
            <div className="sec-title" style={{ textAlign: "left", padding: 0 }}>
              <span className="sub-title mb-15">
                Measurable Results
              </span>
              <h2 className="title mb-45">
                Advanced AI <br /> Agent Suite
              </h2>
              <div className="xb-heading-btn d-flex mb-50" style={{ justifyContent: "flex-start", paddingLeft: "0" }}>
                <Link className="thm-btn agency-btn" to="/about">
                  <span className="text">Know more about us</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
                        <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
                        <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
                        <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
                        <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
                        <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
                        <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
                      </svg>
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
                        <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
                        <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
                        <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
                        <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
                        <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
                        <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
                      </svg>
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>

          {/* Right Column (Stats Grid) */}
          <div className="col-lg-7 col-md-12">
            <div className="row g-4">
              {statsData.map((item, index) => (
                <div className="col-sm-6" key={index}>
                  <div
                    className="stat-card wow fadeInUp"
                    data-wow-delay={`${(index + 1) * 100}ms`}
                    data-wow-duration="600ms"
                    style={{
                      background: "linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "10px",
                      backdropFilter: "blur(40px)",
                      WebkitBackdropFilter: "blur(40px)",
                      height: "100%",
                      transition: "all 0.3s ease",
                      textAlign: "left",
                    }}
                  >
                    <h4 className="stat-value">
                      {item.value}
                    </h4>
                    <div
                      className="label-badge"
                      style={{
                        display: "inline-block",
                        background: "rgba(255, 255, 255, 0.08)",
                        padding: "6px 16px",
                        borderRadius: "100px",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#fff",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        fontFamily: "Inter, sans-serif"
                      }}
                    >
                      {item.label}
                    </div>
                    <p style={{ fontSize: "16px", color: "rgb(255, 255, 255)", lineHeight: "28px", fontWeight: "400", margin: 0, fontFamily: "'DM Sans', sans-serif" }}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
